import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useAuditLog() {
  const { user } = useAuth();
  const location = useLocation();
  const lastLoggedRoute = useRef<string>('');

  useEffect(() => {
    if (!user || location.pathname === lastLoggedRoute.current) return;
    lastLoggedRoute.current = location.pathname;

    const logAccess = async () => {
      try {
        // Get approximate IP and country from a free API
        let ip_address: string | null = null;
        let country: string | null = null;

        try {
          // ipapi.co no envía CORS fiable desde el navegador; ipwho.is permite * (ver CSP connect-src)
          const res = await fetch("https://ipwho.is/", { signal: AbortSignal.timeout(3000) });
          if (res.ok) {
            const geo = await res.json();
            if (geo?.success) {
              ip_address = geo.ip ?? null;
              country = geo.country ?? null;
            }
          }
        } catch {
          // Silently fail - geo info is optional
        }

        await supabase.from('audit_logs').insert({
          user_id: user.id,
          route: location.pathname,
          ip_address,
          country,
          user_agent: navigator.userAgent,
        });
      } catch {
        // Audit logging should never break the app
      }
    };

    logAccess();
  }, [user, location.pathname]);
}
